
export const environment = {
    envName: 'qa',
    production: false,
    hostname: 'qa.uniontracker.toyota.com',
    apiBaseUrl: 'https://qa.uniontracker.toyota.com',
    logger: {
      level: 'DEBUG'
    },
    xApiKey: '',
    TENANT_ID: 'https://login.microsoftonline.com/9107b728-2166-4e5d-8d13-d1ffdf0351ef',
    CLIENT_ID: 'a71f3e2e-d297-45ea-9b99-0acc544385a7',
    REDIRECT_URL: 'https://qa.uniontracker.toyota.com',
    apiUrl: {
        lookupUrl: 'https://api.qa.uniontracker.toyota.com/lookup/',
        suppliermanagUrl: 'https://api.qa.uniontracker.toyota.com/management/'
    }
  };
  
